import React, { useEffect } from "react";
import { getOrgDetails } from "../../services/CommonService";
import { useOrgContext } from "../../Context/orgContext";
const ClientLogo = ({ customClassName }) => {
  const [logo, setLogo] = React.useState("");
  const { setOrgDetials } = useOrgContext();
  
  useEffect(() => {
    getOrgDetails().then((res) => {
      if (res) {
        setOrgDetials(JSON.parse(res));
        setLogo(JSON.parse(res).logo_url);
      }
    });
  }, []);

  return (
    <img
      className={`${customClassName} xl-2:h-[40px] max-w-[200px] h-[40px]`}
      src={logo}
      alt="Client Logo"
    />
  );
};

export default ClientLogo;
